/**
 * Warenpost Shipping Bar
 *
 * Updates #warenpost-shipping-bar based on the contents of #warenpost-cart-data
 * (a JSON array of cart items with warenpost flag and line_price).
 *
 * Loaded once via layout/theme.liquid so it survives AJAX cart-drawer refreshes
 * (Shopify's renderContents() uses innerHTML, which doesn't execute inline scripts —
 * an external script that's already on the page can still react to the new DOM
 * via events + MutationObserver).
 */
(function () {
  'use strict';

  var SHIPPING_COST_LABEL = '4,95 \u20AC';
  var SUCCESS_COLOR = 'var(--color-success-text, #28a745)';
  var PRIMARY_COLOR = 'var(--color-primary, #e87722)';

  function getThresholdCents() {
    return (typeof window.WARENPOST_THRESHOLD_CENTS === 'number' && window.WARENPOST_THRESHOLD_CENTS > 0)
      ? window.WARENPOST_THRESHOLD_CENTS
      : 2000;
  }

  function fmtEur(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function readData() {
    var el = document.getElementById('warenpost-cart-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // DE-Mode session-persistent: einmal aktiviert bleibt es bis der Tab
  // geschlossen wird. Auslands-Besucher die "Lieferung nach DE" wählen sehen
  // so die FREESHIP-Bar auch nach Cart-Refreshes.
  function isDeMode(bar) {
    if (bar.getAttribute('data-country') === 'DE') return true;
    try {
      if (sessionStorage.getItem('bekateq_force_de_shipping') === '1') return true;
    } catch (e) {}
    return bar.getAttribute('data-de-mode') === '1';
  }

  function updateBar(bar) {
    if (!bar) return;
    if (!isDeMode(bar)) return;

    var data = readData();
    if (!Array.isArray(data)) return;

    var hasWarenpost = false;
    var hasPaket = false;
    var warenpostTotalCents = 0;

    for (var i = 0; i < data.length; i++) {
      var item = data[i];
      if (item.warenpost === true) {
        hasWarenpost = true;
        warenpostTotalCents += (item.line_price || 0);
      } else {
        hasPaket = true;
      }
    }

    var msgEl = bar.querySelector('.warenpost-shipping-bar__message');
    var fillEl = bar.querySelector('.warenpost-shipping-bar__fill');
    var iconEl = bar.querySelector('.warenpost-shipping-bar__icon');
    if (!msgEl || !fillEl) return;

    function showSuccess(msg) {
      msgEl.innerHTML = '<strong style="color:' + SUCCESS_COLOR + ';">' + msg + '</strong>';
      fillEl.style.width = '100%';
      fillEl.style.background = SUCCESS_COLOR;
      if (iconEl) iconEl.style.background = SUCCESS_COLOR;
    }

    var threshold = getThresholdCents();

    if (!hasWarenpost) {
      showSuccess('Kostenloser Versand innerhalb Deutschlands');
    } else if (hasPaket) {
      showSuccess('Kostenloser Versand f\u00FCr Ihre gesamte Bestellung');
    } else if (warenpostTotalCents >= threshold) {
      showSuccess('Kostenloser Versand innerhalb Deutschlands');
    } else {
      var deficitCents = threshold - warenpostTotalCents;
      var progress = Math.min((warenpostTotalCents / threshold) * 100, 100);
      msgEl.innerHTML =
        'Noch <strong>' + fmtEur(deficitCents) + '</strong> bis zum kostenlosen Versand ' +
        '<span style="color:#888;font-size:0.85em;">(Aktuell: ' + SHIPPING_COST_LABEL + ' Versand)</span>';
      fillEl.style.width = progress + '%';
      fillEl.style.background = PRIMARY_COLOR;
      if (iconEl) iconEl.style.background = '#ccc';
    }
  }

  function updateAll() {
    var bars = document.querySelectorAll('.warenpost-shipping-bar');
    for (var i = 0; i < bars.length; i++) updateBar(bars[i]);
  }

  function activateDeMode(bar) {
    if (!bar) return;
    bar.setAttribute('data-de-mode', '1');
    var toggle = bar.querySelector('[data-de-toggle]');
    if (toggle) toggle.setAttribute('aria-pressed', 'true');
    var track = bar.querySelector('.warenpost-shipping-bar__track');
    if (track) track.removeAttribute('hidden');
    try { sessionStorage.setItem('bekateq_force_de_shipping', '1'); } catch (e) {}
    updateBar(bar);
  }

  function restoreFromSession() {
    // Wenn User DE-Modus in vorheriger Page-Load aktiviert hat, wiederherstellen.
    try {
      if (sessionStorage.getItem('bekateq_force_de_shipping') !== '1') return;
    } catch (e) { return; }
    var bars = document.querySelectorAll('.warenpost-shipping-bar');
    for (var i = 0; i < bars.length; i++) activateDeMode(bars[i]);
  }

  function init() {
    updateAll();
    restoreFromSession();

    // DE-Toggle (für Auslands-Besucher): klick → forcie DE-Modus
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-de-toggle]');
      if (!t) return;
      var bar = t.closest('.warenpost-shipping-bar');
      activateDeMode(bar);
    });

    document.addEventListener('cart:refresh', updateAll);
    document.addEventListener('cart:updated', updateAll);
    document.addEventListener('on:cart:add', updateAll);
    // Quantity changes inside the drawer / cart page bubble up this event.
    document.addEventListener('on:line-item:change', updateAll);

    // Re-run when the cart-drawer section is replaced via Section Rendering API
    // (innerHTML doesn't fire load events, so we observe DOM mutations).
    var bodyObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('.warenpost-shipping-bar')) {
            updateAll();
            return;
          }
          if (node.querySelector && node.querySelector('.warenpost-shipping-bar')) {
            updateAll();
            return;
          }
        }
      }
    });
    if (document.body) {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
